import { Button, Typography } from '@mui/material';

import BaseDialog from '@/components/shared/Dialog/BaseDialog';

interface NotSpecifiedRoleDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

function NotSpecifiedRoleDialog({ open, onConfirm, onCancel }: NotSpecifiedRoleDialogProps) {
  return (
    <BaseDialog
      open={open}
      onClose={onCancel}
      title='Role not specified'
      hasCloseButton
      footer={
        <>
          <Button variant='outlined' onClick={onCancel} data-testid='not-specified-role-dialog-cancel'>
            Stay
          </Button>
          <Button variant='contained' color='error' onClick={onConfirm} data-testid='not-specified-role-dialog-confirm'>
            Leave
          </Button>
        </>
      }
    >
      <Typography>Are you sure to leave without specifying role values?</Typography>
    </BaseDialog>
  );
}

export default NotSpecifiedRoleDialog;
